import axios from "../../../lib/axios";
import { ISubAdminPayload } from "../../../types/api/subAdmin";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { AxiosResponse } from "axios";

export const subAdminList = (
  qData: QData & { name?: string; email?: string },
): Promise<AxiosResponse<TResponseWithQData<ISubAdminPayload[]>>> => {
  return axios.get("/admin/sub-admin", { params: qData });
};

export const subAdminDetail = (
  id: string,
): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> => {
  return axios.get(`/admin/sub-admin/${id}`);
};

export const createSubAdmin = (
  data: Partial<ISubAdminPayload>,
): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> => {
  return axios.post("/admin/sub-admin", data);
};

export const updateSubAdmin = ({
  id,
  data,
}: {
  id: string;
  data: Partial<ISubAdminPayload>;
}): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> => {
  return axios.put(`/admin/sub-admin/${id}`, data);
};
